<template>
  <div class="col-12 notification-phone-preview">
    <div class="notification-preview" :class="[display ==='small' ? 'small' : '']">
      <img :src="require('@/assets/img/galaxyS10.png')"/>
      <Notification :description="$t(description)" :title="$t(title)"></Notification>
    </div>

    <div v-if="display ==='small'" class="notification-phone-preview-small-footer"></div>
  </div>
</template>
<script>
import Notification from '../devices/Notification'

export default {
  name: 'NotificationPhonePreview',
  props: {
    display: {
      type: String,
      required: false,
      default: "large"
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: false,
      default: ""
    }
  },
  components: {
    Notification
  },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style lang="scss" scoped>

</style>
